import { Provider } from 'jotai';
import Layout from './pages/_layout';
import HomePage from './pages/home';

// Single page — no router. The portal is a front door, not a destination.
export default function App() {
  return (
    <Provider>
      <Layout>
        <HomePage />
      </Layout>
    </Provider>
  );
}
